interface IGetTranslationByPartnerAccessParameters {
  isRetail?: boolean
  isDistributor?: boolean
}

export const getTranslationByPartnerAccess = (
  translationKey: string,
  options: IGetTranslationByPartnerAccessParameters = {}
) => {
  const { isRetail = false, isDistributor = false } = options

  if (isRetail) {
    return `${translationKey}-retail`
  }

  if (isDistributor) {
    return `${translationKey}-distributor`
  }

  return translationKey
}
